import { useSelector } from 'react-redux';

import { getEnvironment } from '#src/store/environment/selectors';
import { CloudinaryImage } from '#src/components/CloudinaryImage';

export const CloudinaryChart = () => {
  const { QUIZ_CHECKOUT_CHART_PUBLIC_ID: publicId } =
    useSelector(getEnvironment);
  return !publicId ? null : <CloudinaryImage image={{ publicId }} />;
};
